import { ETATS_EXPOSITION, type EtatExposition } from '@artosera/shared';

/**
 * L'état d'une exposition est posé à la main (§ 15.2, D13) : rien côté API
 * n'impose un ordre entre `brouillon`, `annoncee`, `en_cours` et `passee` —
 * `PATCH …/expositions/:id` accepte n'importe laquelle des quatre valeurs.
 * Cette table est donc une convention d'ÉCRAN, pas une règle du serveur :
 * elle propose l'état suivant naturel (le menu déroulant), tout en laissant
 * une correction manuelle vers n'importe quel autre état (même geste que la
 * « correction à la main » du statut d'une œuvre, `oeuvres/statutUi.ts`).
 */
const SUITE_NATURELLE: Record<EtatExposition, EtatExposition | null> = {
  brouillon: 'annoncee',
  annoncee: 'en_cours',
  en_cours: 'passee',
  passee: null,
};

/** L'état suivant proposé en premier dans le menu, ou `null` en fin de course. */
export function etatSuivant(etat: EtatExposition): EtatExposition | null {
  return SUITE_NATURELLE[etat];
}

/** Tous les autres états, pour la correction manuelle. */
export function autresEtats(etat: EtatExposition): readonly EtatExposition[] {
  return ETATS_EXPOSITION.filter((code) => code !== etat);
}
